import { useEffect, useState } from 'react';
import FAQ from '../../components/detailsTabs/FAQ/FAQ';
import Pagination from '../../components/pagination/Pagination';
import getFaqs, { faqCount } from './supFaqFunction/faq';
import ReactLoading from 'react-loading';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteFaq } from './supFaqFunction/deleteFaq';

export default function SupFaq() {
    const navigate = useNavigate();
    const [faqData, setFaqData] = useState([]);
    const [selectedType, setSelectedType] = useState('trip');
    const [loading, setLoading] = useState(false);
    const [offSet, setOffSet] = useState(0);
    const [deleteModal, setDeleteModal] = useState(false);
    const [rowClickId, setRowClickId] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [load, setLoad] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const limit = 10;
    const totalData = totalCount;
    const { mode } = useParams();

    const refresh = () => {
        setLoad(!load);
    };

    useEffect(() => {
        const fetchFaqData = async () => {
            try {
                await getFaqs(setFaqData, setLoading, selectedType, limit, offSet);
            } catch (err) {
                console.log('Failed to fetch faq');
            }
        };

        fetchFaqData();
        //eslint-disable-next-line
    }, [load, selectedType]);

    useEffect(() => {
        faqCount(setTotalCount, setLoading, selectedType);
        //eslint-disable-next-line
    }, [selectedType]);

    const handleDelete = (id) => {
        deleteFaq(id, setLoading, refresh, setDeleteModal);
    };

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supFilter'>
                <h1 className='supportHeader'>FAQ</h1>
                <div>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value='trip'>Trip</option>
                        <option value='camp'>Camp</option>
                        <option value='guide'>Guide</option>
                    </select>
                    <button
                        className='addDropdownBtn blueBtn'
                        onClick={() =>
                            navigate(`/support/${mode}/faq/upload`, { state: { selectedType: selectedType } })
                        }
                    >
                        Add FAQ
                    </button>
                </div>
            </div>
            <div className='customContainer privacy supFaq'>
                <FAQ
                    data={faqData}
                    page='support'
                    handleDelete={handleDelete}
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    rowClickId={rowClickId}
                    setRowClickId={setRowClickId}
                />
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={faqData.length}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
            </div>
        </>
    );
}
